var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2006",
    "data-name": "Group 2006",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.026,
    height: 18.037,
    viewBox: "0 0 18.026 18.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5066",
    "data-name": "Rectangle 5066",
    width: 18.026,
    height: 18.037,
    fill: "#6a6873"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M9.012,0h7.249a1.6,1.6,0,0,1,1.764,1.764q0,5.63,0,11.26a1.6,1.6,0,0,1-1.766,1.762c-1.372,0-2.745.006-4.117-.005a.556.556,0,0,0-.5.246c-.7.9-1.41,1.785-2.121,2.673-.358.448-.67.448-1.025,0-.7-.88-1.41-1.755-2.1-2.647a.646.646,0,0,0-.589-.275c-1.372.011-2.745.008-4.117,0A1.582,1.582,0,0,1,0,13.1q0-5.7,0-11.4A1.581,1.581,0,0,1,1.693,0Q5.353,0,9.012,0m0,16.642c.707-.891,1.382-1.733,2.046-2.583a.793.793,0,0,1,.688-.336c1.5.011,3,.006,4.5,0,.542,0,.717-.174.717-.713q0-5.63,0-11.26c0-.518-.179-.7-.7-.7H1.772c-.541,0-.714.173-.714.716q0,5.613,0,11.225c0,.562.169.729.736.729,1.466,0,2.932.011,4.4-.007a.935.935,0,0,1,.831.409c.641.835,1.305,1.652,1.989,2.512",
    transform: "translate(0.001 0.001)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M31.988,38.974c.445,0,.89,0,1.335,0s.639.178.644.6q.015,1.387,0,2.774c0,.408-.2.6-.618.6q-1.37.014-2.739,0c-.433,0-.621-.2-.623-.627q-.006-1.37,0-2.739c0-.425.2-.609.632-.613.457,0,.913,0,1.37,0m.883,1.08H31.063v1.812h1.808Z",
    transform: "translate(-27.872 -36.229)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M105.993,76.538q-1.81,0-3.619,0a1.689,1.689,0,0,1-.383-.03A.519.519,0,0,1,102,75.5a1.9,1.9,0,0,1,.384-.027q3.584,0,7.168,0c.07,0,.141,0,.211,0,.365.022.582.215.589.52a.533.533,0,0,1-.6.544c-1.253.008-2.506,0-3.76,0",
    transform: "translate(-94.442 -70.155)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M105.905,152.131q-1.845,0-3.69,0c-.445,0-.687-.185-.691-.519s.248-.539.678-.539q3.707,0,7.415,0c.43,0,.678.2.672.542s-.244.515-.658.516q-1.863,0-3.725,0",
    transform: "translate(-94.376 -140.435)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M31.394,122.806c.573-.577,1.088-1.1,1.612-1.622a.524.524,0,0,1,.826-.014.509.509,0,0,1-.049.729q-.975.989-1.964,1.964a.516.516,0,0,1-.805,0c-.289-.275-.572-.556-.845-.845a.526.526,0,1,1,.738-.749c.162.151.3.328.488.538",
    transform: "translate(-27.886 -112.459)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M103.814,120.418c-.539,0-1.078,0-1.617,0-.432,0-.68-.213-.67-.548s.253-.518.665-.519q1.67-.006,3.34,0c.4,0,.655.215.657.531s-.249.53-.651.535c-.574.007-1.148,0-1.723,0",
    transform: "translate(-94.379 -110.945)",
    fill: "#6a6873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M103.852,44.961c-.563,0-1.125,0-1.688,0-.4,0-.644-.221-.634-.547s.24-.509.629-.51q1.706,0,3.411,0c.38,0,.62.211.621.523a.552.552,0,0,1-.616.533c-.574.006-1.149,0-1.723,0",
    transform: "translate(-94.382 -40.81)",
    fill: "#6a6873"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.186c2244.svg";
export { ForwardRef as ReactComponent };